import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { returnDynamicError, returnText } from '../../../state/selectors';
import { environment } from '../../../environments/environment';
import { HelperFunctionsService } from '../../services/helper-functions.service';

@Component({
  selector: 'app-error-toast',
  templateUrl: './error-toast.component.html',
  styleUrls: ['./error-toast.component.scss']
})
export class ErrorToastComponent implements OnInit, OnDestroy {
  errorMessage = '';
  assistantText = '';
  incidentText = '';

  myItDigitalAssistant = environment.NG_APP_MYIT_DIGITAL_ASSISTANT;
  reportAnIncident = environment.NG_APP_REPORT_AN_INCIDENT;

  private subscriptions: Subscription[] = [];
  private msgKey = 'Token_Process_Error';

  constructor(
    private store: Store,
    private helperService: HelperFunctionsService
  ) {}

  ngOnInit(): void {
    // Subscribe to the msgKey from the helper service
    this.subscriptions.push(
      this.helperService.getErrorToastMsgKey$().subscribe(key => {
        this.msgKey = key;
        // Update error message when msgKey changes
        this.updateErrorMessage();
      })
    );

    // Subscribe to dynamic error value in store
    this.subscriptions.push(
      this.store.select(returnDynamicError).subscribe(val => {
        if (this.msgKey === 'Dynamic_Error') {
          this.errorMessage = val;
        }
      })
    );

    // Subscribe to link text translations
    this.subscriptions.push(
      this.store
        .select(returnText('MyIT_Digital_Assistant'))
        .subscribe(val => (this.assistantText = val))
    );
    this.subscriptions.push(
      this.store
        .select(returnText('Report_An_Incident'))
        .subscribe(val => (this.incidentText = val))
    );
  }

  /**
   * Update the error message based on the current msgKey
   */
  private updateErrorMessage(): void {
    if (this.msgKey === 'Dynamic_Error') {
      // Rely on the single `ngOnInit` subscription to update `errorMessage`.
      // Clear the current message to avoid showing a stale translation.
      this.errorMessage = '';
      return;
    } else {
      // Unsubscribe from previous error message subscription if it exists
      if (this.subscriptions.length > 0) {
        this.subscriptions[0]?.unsubscribe();
      }
      // Subscribe to the new error message translation
      const sub = this.store
        .select(returnText(this.msgKey))
        .subscribe(val => {
          this.errorMessage = val;
        });
      // Store this subscription for cleanup
      if (this.subscriptions.length === 0) {
        this.subscriptions.push(sub);
      } else {
        this.subscriptions[0] = sub;
      }
    }
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
